"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/button/style");
var _button = _interopRequireDefault(require("antd/lib/button"));
require("antd/lib/input/style");
var _input = _interopRequireDefault(require("antd/lib/input"));
require("antd/lib/message/style");
var _message2 = _interopRequireDefault(require("antd/lib/message"));
var _react = _interopRequireWildcard(require("react"));
var _message3 = require("../../servers/message");
var _Captcha = _interopRequireDefault(require("../Captcha"));
var _classnames = _interopRequireDefault(require("classnames"));
var _sendvc = require("../../interface/sendvc");
var _consts = require("../../consts");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/**
 * 验证码最大长度
 */
var MAX_LENGTH = 6;
var COUNT_DOWN = 60;
var Index = function Index(props) {
  var sendInputId = props.sendInputId,
    sendBtnId = props.sendBtnId,
    className = props.className,
    captchaWrapClassName = props.captchaWrapClassName,
    account = props.account,
    phoneNumber = props.phoneNumber,
    disabled = props.disabled,
    vcValue = props.vcValue,
    _props$sendUserType = props.sendUserType,
    sendUserType = _props$sendUserType === void 0 ? _sendvc.SendVCType.ACCOUNT : _props$sendUserType,
    _props$placeholder = props.placeholder,
    placeholder = _props$placeholder === void 0 ? '' : _props$placeholder,
    sourceType = props.sourceType,
    _props$prefix = props.prefix,
    prefix = _props$prefix === void 0 ? false : _props$prefix,
    onBlurInput = props.onBlurInput,
    onFocusInput = props.onFocusInput,
    onChangeInput = props.onChangeInput,
    onSuccess = props.onSuccess,
    onError = props.onError,
    getClock = props.getClock,
    onValid = props.onValid;
  /**
   * 是否需要图形
   */
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    validateCaptcha = _useState2[0],
    setValidateCaptcha = _useState2[1];
  /**
   * 是否显示验证码图层
   */
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    visibleCaptcha = _useState4[0],
    setVisibleCaptcha = _useState4[1];
  /**
   * 计时器的数字显示
   */
  var _useState5 = (0, _react.useState)(0),
    _useState6 = _slicedToArray(_useState5, 2),
    clock = _useState6[0],
    setClock = _useState6[1];
  /**
   * 文本显示
   */
  var _useState7 = (0, _react.useState)('获取验证码'),
    _useState8 = _slicedToArray(_useState7, 2),
    codeTxt = _useState8[0],
    setCodeTxt = _useState8[1];
  /**
   * 如果需要显示图形验证码，对应的BID
   */
  var _useState9 = (0, _react.useState)(''),
    _useState10 = _slicedToArray(_useState9, 2),
    bid = _useState10[0],
    setBid = _useState10[1];
  /**
   * 计时器
   */
  var intervalRef = (0, _react.useRef)(null);
  /**
   * 首次加载时调用，用来请求业务验证码数据情况
   */
  (0, _react.useEffect)(function () {
    keepCountDown();
    handleValidateCaptcha();
  }, []);
  /**
   * 继续倒计时
   */
  var keepCountDown = function keepCountDown() {
    // 处理倒计时业务
    var lastSendTime = localStorage.getItem("".concat(sourceType, "_time"));
    if (null !== lastSendTime) {
      var curDate = Math.round(Date.now() / 1000);
      if (curDate - parseInt(lastSendTime) < COUNT_DOWN) {
        countDown(COUNT_DOWN - (curDate - parseInt(lastSendTime)));
      }
    }
  };
  /**
   * 请求接口，获取接口使用验证码情况
   */
  var handleValidateCaptcha = function handleValidateCaptcha() {
    (0, _message3.getSmsBid)(sourceType).then(function (res) {
      if (res.retCode != 'SUCCESS') {
        _message2.default.error('获取验证信息失败');
        return;
      }
      setValidateCaptcha(res.data.needCaptcha);
      setBid(res.data.bid);
    });
  };
  /**
   * 发送按钮事件
   */
  var handleClick = function handleClick() {
    if (onValid && !onValid()) {
      return;
    }
    if (validateCaptcha) {
      setVisibleCaptcha(true);
    } else {
      handleSendMsg();
    }
  };
  /**
   *  实际发送短信验证码方法
   * @param validationCode
   */
  var handleSendMsg = function handleSendMsg(validationCode) {
    setCodeTxt('发送中...');
    if (sendUserType === _sendvc.SendVCType.ACCOUNT) {
      // 通过账号发送
      (0, _message3.sendSmsCodeByAccount)(_objectSpread({
        sendTarget: account,
        sourceType: sourceType
      }, validationCode)).then(function (r) {
        sendAfter(r);
      });
    } else {
      // 通过手机号发送
      (0, _message3.sendSmsCodeByPhone)(_objectSpread({
        sendTarget: phoneNumber,
        sourceType: sourceType
      }, validationCode)).then(function (r) {
        sendAfter(r);
      });
    }
  };
  /**
   * 发送后的处理
   * @param res
   */
  var sendAfter = function sendAfter(res) {
    if (res.retCode !== 'SUCCESS') {
      onError && onError(res);
      setCodeTxt('获取验证码');
      return;
    }
    var countDownTime = COUNT_DOWN;
    var curDate = Math.round(Date.now() / 1000);
    localStorage.setItem("".concat(sourceType, "_time"), String(curDate));
    // 发送短信成功时回调
    onSuccess && onSuccess();
    countDown(countDownTime);
  };
  /**
   * 图形验证码的操作提交
   * @param props
   */
  var handleCaptchaSubmit = function handleCaptchaSubmit(props) {
    // 关闭验证码
    setVisibleCaptcha(false);
    handleSendMsg(_objectSpread({}, props));
  };
  /**
   * 倒计时
   * @param time
   */
  var countDown = function countDown(time) {
    getClock === null || getClock === void 0 ? void 0 : getClock(time);
    var t = time;
    intervalRef.current = setInterval(function () {
      if (0 < t) {
        t--;
        setClock(t);
        setCodeTxt(t ? "".concat(t, "\u79D2\u540E\u53EF\u91CD\u65B0\u83B7\u53D6") : '重新获取');
      } else {
        // 倒计时结束
        clearInterval(intervalRef.current);
        intervalRef.current = null;
        setClock(0);
        setCodeTxt('重新获取');
        getClock === null || getClock === void 0 ? void 0 : getClock(0);
      }
    }, _consts.DURATION);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('gy_send_msg_wrap', className, 'gy_default_send_msg_wrap')
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_send_msg_merge"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_send_msg_item"
  }, prefix && /*#__PURE__*/_react.default.createElement("span", {
    className: "gy_send_msg_icon"
  }), /*#__PURE__*/_react.default.createElement(_input.default, {
    className: "gy_send_msg_input",
    placeholder: placeholder,
    autoComplete: "off",
    maxLength: MAX_LENGTH,
    onChange: onChangeInput,
    onBlur: onBlurInput,
    onFocus: onFocusInput,
    id: sendInputId,
    value: vcValue
  })), /*#__PURE__*/_react.default.createElement(_button.default, {
    className: "gy_send_msg_btn",
    id: sendBtnId,
    onClick: function onClick() {
      return handleClick();
    },
    disabled: disabled || clock !== 0 || codeTxt === '发送中...'
  }, codeTxt)), validateCaptcha && /*#__PURE__*/_react.default.createElement(_Captcha.default, {
    bId: bid || '',
    visible: visibleCaptcha,
    onSubmit: handleCaptchaSubmit,
    onClose: function onClose() {
      return setVisibleCaptcha(false);
    },
    wrapClassName: captchaWrapClassName
  }));
};
var _default = Index;
exports.default = _default;